module.exports = __webpack_public_path__ + "assets/logo_pred.660ac0e8.svg";